// utils/loginReturn.ts
//
// A guest sent to login from a page (OTC, Digital Gold, a protected /fa/my page) comes back to
// that page once signed in. Callers put the page in router state as `from`; login carries it to
// the OTP step as `returnTo`; whichever step finishes the sign-in navigates there.
//
// Router state can be set by anyone who links into the app, so only internal, non-auth paths are
// accepted: anything else would let a crafted link send a freshly signed-in user off-site.

import { DASHBOARD } from '@/pages/routes';

/** `value` if it is safe to return to after login, else undefined. */
export const safeReturnPath = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  // "//host" and "/\host" are treated by browsers as another origin.
  if (
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.startsWith('/\\')
  )
    return undefined;
  if (value.startsWith('/fa/auth') || value.startsWith('/auth'))
    return undefined;
  return value;
};

/** The page a login opened with `state.from` should end on. */
export const returnPathFrom = (state: unknown): string | undefined =>
  safeReturnPath((state as { from?: unknown } | null)?.from);

/** Where a finished sign-in goes: the carried page, or the dashboard. */
export const afterLoginPath = (returnTo: unknown): string =>
  safeReturnPath(returnTo) ?? DASHBOARD;
